module.exports = __webpack_public_path__ + "static/media/lily.9db0531b.jpg";